// extracted by mini-css-extract-plugin
export default {"about":"description_about__3N98h","productDescription":"description_productDescription__r6iCf","readMore":"description_readMore__x63zV"};